<template>
    <div class="newCustomer">
        <newCustomerComponent></newCustomerComponent>
    </div>
</template>

<style scoped>
    .newCustomer{
        background : #F5F7FA;
    }
</style>

<script>
    import newCustomerComponent from '@/components/addCustomer_component.vue';

    export default {
        name: 'NewCustomer',
        data() {
            return {
            }
        },
        components: {
            newCustomerComponent
        }
    }
</script>